<template>
    <Navbar></Navbar>
    <div class="contact-hero">
        <div class="contact-us-title">
            Business Cooperation
        </div>
        <div class="contact-hero-inner">
            <div class="contact-hero-card">
                <div class="contact-hero-inner-item">
                    <div class="contact-hero-company">FINEST Automotive Technology Group Co., Ltd.</div>
                    <div class="contact-hero-addr">Address: No.75, Dongsheng Road, East Second Ring Road, Lianchi
                        District,Baoding
                        City,<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Hebei
                        Province.</div>
                </div>
            </div>
            <div class="contact-hero-map">
                <div class="map-img">
                    <img data-src="/assets/contact/map.jpg" alt="contact map">
                </div>
            </div>
        </div>
    </div>
    <div class="contact-us">
        <div class="contact-us-list">
            <div class="contact-us-item">
                <div class="contact-us-t1">
                    Electronics Product Sales
                </div>
                <div class="contact-us-d">
                    <div>
                        Address: No.668, Caihong Road, Zhangjiagang Economic & Technological
                        Development<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Zone,
                        Jiangsu Province.
                    </div>
                    <div>
                        E - mail: chenhong@finestauto.com
                    </div>
                    <div>
                        Phone&nbsp;&nbsp;: +86-13663123760
                    </div>
                </div>
            </div>

            <div class="contact-us-item">
                <div class="contact-us-t1">
                    Powertrain Sales
                </div>
                <div class="contact-us-d">
                    <div>
                        Address: No.75, Dongsheng Road, East Second Ring Road, Lianchi District, Baoding City,
                        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Hebei
                        Province.
                    </div>
                    <div>
                        E - mail: fcdlxsz@gwm.cn
                    </div>

                    <div>
                        Phone&nbsp;&nbsp;: +86-18633299228, +86-18633299403
                    </div>
                </div>
            </div>
        </div>

    </div>

    <Footer></Footer>
</template>

<script setup>
import { ref } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';



</script>

<script>
export const pageConfig = {
    title: 'Contact Us - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/contact-us.html'
};

import { createApp } from 'vue';
import App from './contact-us.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}


// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./contact-us.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped>
.contact-hero {
    padding: 2.1rem 1.56rem 0rem;
    width: calc(100% - 3.12rem);

    .contact-us-title {
        font-size: 0.4rem;
        font-weight: 500;
        color: #000;
        margin-bottom: 0.4rem;
    }

    .contact-hero-inner {
        display: flex;
        align-items: stretch;
        justify-content: space-between;
    }

    .contact-hero-card {
        width: 49.3%;
        border-radius: 0.25rem;
        background: #F6F8FA;
        display: flex;
        flex-direction: column;

        .contact-hero-inner-item {
            padding: 0.58rem 0.44rem;
        }

        .contact-hero-title {
            font-size: 0.5rem;
            font-weight: 500;
            margin-bottom: 0.3rem;
        }

        .contact-hero-company {
            font-size: 0.28rem;
            font-weight: 700;
            color: #000;
            margin-bottom: 0.56rem;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                width: 0.38rem;
                height: 0.02rem;
                background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
                bottom: -0.2rem;
                left: 0;
            }
        }

        .contact-hero-addr {
            font-size: 0.16rem;
            color: #999;
            line-height: 0.3rem;
        }
    }

    .contact-hero-map {
        width: 49.3%;

        .map-img {
            width: 100%;
            height: 100%;
            border-radius: 0.25rem;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
            }
        }
    }

    @media (max-width: 768px) {
        .contact-hero-inner {
            flex-direction: column;
        }

        .contact-hero-card,
        .contact-hero-map {
            width: 100%;
        }

        .contact-hero-map {
            .map-img {
                height: 8rem;
            }
        }
    }
}

.contact-us {
    padding: 0.25rem 1.56rem 1.4rem;
    width: calc(100% - 3.12rem);

    .contact-us-title {
        font-size: 0.4rem;
        font-weight: 500;
        color: #000;
        margin-bottom: 0.4rem;
    }

    .contact-us-list {
        display: flex;
        align-items: center;
        gap: 0.2rem;
        margin-bottom: 1.4rem;
    }

    .contact-us-item {
        width: 50%;
        border-radius: 0.25rem;
        height: 3rem;
        background: #F6F8FA;
        padding: 0.58rem 0.44rem;

        .contact-us-t1 {
            font-size: 0.25rem;
            font-weight: 600;
            color: #000;
            margin-bottom: 0.56rem;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                width: 0.38rem;
                height: 0.02rem;
                background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
                bottom: -0.2rem;
                left: 0;
            }
        }

        .contact-us-d {
            font-size: 0.16rem;
            color: #999;
            line-height: 0.3rem;
            font-weight: 400
        }
    }

    .contact-us-flex {
        width: 100%;
        display: flex;
        align-items: center;
        border-radius: 0.25rem;
        overflow: hidden;

        .img-box {
            width: 50%;
        }

        .contact-us-item {
            width: 50%;
            padding: 0.58rem 0.68rem;
            border-radius: unset;
        }
    }
}

@media (max-width: 768px) {
    .contact-hero {
        padding: 2.02rem 0.45rem 0;
        width: calc(100% - 0.9rem);

        .contact-hero-inner {
            flex-direction: column-reverse;
            background: #F6F8FA;

            .contact-hero-card {
                width: 100%;

                .contact-hero-addr {
                    font-size: 0.2rem;
                    color: #000;
                }
            }

            .contact-hero-map {
                width: 100%;
            }
        }
    }

    .contact-us {
        padding: 0.3rem 0.45rem 0;
        width: calc(100% - 0.9rem);

        .contact-us-list {
            flex-direction: column;
            gap: 0.3rem;
        }

        .contact-us-item {
            width: calc(100% - 1.36rem);
            padding: 0.58rem 0.68rem;
            height: auto;

            .contact-us-t1 {
                font-size: 0.28rem;
            }

            .contact-us-d {
                font-size: 0.2rem;
                font-weight: 400;
                color: #000;
            }
        }
    }
}
</style>